import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PATHS } from 'src-ironside/app-routing.module';
import { BreadCrumbItem } from 'src-ironside/shared/components/bread-crumb/bread-crumb.component';

@Component({
    selector: 'app-logistic-import',
    templateUrl: './logistic-import.component.html',
    styleUrls: ['./logistic-import.component.scss'],
})
export class LogisticImportComponent implements OnInit {
    constructor(private translate: TranslateService) {}

    ngOnInit(): void {}

    get breadCrumb() {
        let breadCrumbs: BreadCrumbItem[] = [
            { name: 'Accueil', url: PATHS.home_en },
            { name: 'Import des trames' },
        ];
        return breadCrumbs;
    }
}
